module.exports = "/img/_/_/_/assets/images/creeper/book/common//21.jpg?a3c53ad7be01f9d5d03208d3b45b2e04";